import React from "react";
import { Empty } from "antd";
import { Typography } from "antd";

const { Title } = Typography;

const NoContentFound = () => {
  return (
    <div className="no-records">
      <Empty description={'No record found.'} />
    </div>
  );
};

export default NoContentFound;
